export default {
  'settings.title': 'Settings',
  'settings.subtitle': 'Manage your organization, operations, people and account.',
  'settings.subtitleLong': 'Manage your organization, operations, people and account — all in one place.',
  'settings.workspace': 'Workspace',
  'settings.groupOrganization': 'Organization',
  'settings.groupOperations': 'Operations',
  'settings.groupPeople': 'People',
  'settings.groupAccount': 'Account',
  'settings.company': 'Company',
  'settings.companyDesc': 'Branding on every report & PDF',
  'settings.ledgers': 'Ledgers',
  'settings.ledgersDesc': 'Books per branch',
  'settings.line': 'Service lines',
  'settings.lineDesc': 'Locations you operate from',
  'settings.banks': 'Banks',
  'settings.banksDesc': 'Company bank accounts for online payments & audit',
  'settings.finance': 'Finance defaults',
  'settings.financeDesc': 'Interest % & OP interest for finance',
  'settings.financialYear': 'Financial year',
  'settings.financialYearDesc': 'Year used by reports & dashboards',
  'settings.sms': 'SMS reminders',
  'settings.smsDesc': 'Payment reminder days & SMS usage',
  'settings.payment': 'Payments',
  'settings.paymentDesc': 'Settlement preferences',
  'settings.owners': 'Owners',
  'settings.ownersDesc': 'Cap table and contacts',
  'settings.admins': 'Workspace admins',
  'settings.adminsDesc': 'Desk roles and accountability',
  'settings.subscription': 'Subscription',
  'settings.subscriptionDesc': 'Plan, billing & renewal',
  'settings.profile': 'Profile',
  'settings.profileDesc': 'Identity and sign-in security',
  'settings.deleteAccount': 'Delete account',
  'settings.deleteAccountDesc': 'Request permanent workspace removal',
  'settings.language': 'Language',
  'settings.languageDesc': 'Website display language',
  'settings.languageTitle': 'Display language',
  'settings.languageHint': 'Choose how menus, labels, and buttons appear across the workspace.',
  'settings.languageSaved': 'Language updated for this device.',

  'settings.font': 'Font size',
  'settings.fontDesc': 'Text size on phone and desktop',
  'settings.fontTitle': 'Display font size',
  'settings.fontHint': 'Choose how large menus, labels, and amounts appear. Hindi and Telugu get an extra boost on mobile for readability.',
  'settings.fontSaved': 'Font size updated for this device.',
  'settings.fontPreviewLine': 'Sample text — menus, labels, and EMI amounts scale together.',
  'font.compact': 'Compact',
  'font.comfortable': 'Comfortable',
  'font.large': 'Large',
  'font.extraLarge': 'Extra large',
  'font.maximum': 'Maximum',

  'settings.theme': 'Color theme',
  'settings.themeDesc': 'Accent color across the workspace',
  'settings.themeTitle': 'Workspace color theme',
  'settings.themeHint': 'Pick an accent color — saved to your account so it follows you on every phone and browser.',
  'settings.themeSaved': 'Color theme saved to your account.',
  'settings.themePreview': 'Live preview',
  'settings.themeActiveBadge': 'Active',
  'theme.emerald': 'Emerald',
  'theme.blue': 'Blue',
  'theme.violet': 'Violet',
  'theme.rose': 'Rose',
  'theme.amber': 'Amber',
  'theme.indigo': 'Indigo',
  'theme.teal': 'Teal',
  'theme.orange': 'Orange',

  'settings.fontFineTune': 'Fine-tune with slider',
  'settings.fontCurrent': 'Current: {{percent}}',
  'settings.fontLivePreview': 'Live preview',
  'settings.fontReset': 'Reset to default',
  'settings.fontSavedAt': 'Saved at {{percent}}',

  'settingsForm.companyIdentity': 'Company identity',
  'settingsForm.legalName': 'Legal company name',
  'settingsForm.displayName': 'Display / trade name',
  'settingsForm.tagline': 'Tagline',
  'settingsForm.logo': 'Logo URL',
  'settingsForm.contact': 'Contact',
  'settingsForm.phone': 'Primary phone',
  'settingsForm.altPhone': 'Alternate phone',
  'settingsForm.email': 'Email',
  'settingsForm.website': 'Website',
  'settingsForm.addressLine1': 'Address line 1',
  'settingsForm.addressLine2': 'Address line 2 (optional)',
  'settingsForm.city': 'City',
  'settingsForm.state': 'State',
  'settingsForm.pincode': 'Pincode',
  'settingsForm.country': 'Country',
  'settingsForm.registration': 'Registration',
  'settingsForm.gstin': 'GSTIN',
  'settingsForm.pan': 'PAN',
  'settingsForm.partners': 'Partners / directors',
  'settingsForm.saveCompany': 'Save company profile',
  'settingsForm.ledgerTitle': 'One book per branch',
  'settingsForm.ledgerHint': 'Each ledger gets its own desk login and isolated records.',
  'settingsForm.ledgerName': 'Ledger name',
  'settingsForm.deskLogin': 'Desk login email',
  'settingsForm.createLedger': 'Create ledger',
  'settingsForm.serviceLines': 'Service lines',
  'settingsForm.addLine': 'Add line',
  'settingsForm.banksList': 'Company bank accounts',
  'settingsForm.addBank': 'Add bank account',
  'settingsForm.bankName': 'Bank name',
  'settingsForm.accountName': 'Account name',
  'settingsForm.accountNumber': 'Account number',
  'settingsForm.branch': 'Branch',
  'settingsForm.ifsc': 'IFSC',
  'settingsForm.confirmDeleteBank': 'Delete this bank account?',
  'settingsForm.noBanksYet': 'No bank accounts yet. Add one for online payment tracking.',
  'settingsForm.defaultInterest': 'Default interest %',
  'settingsForm.opInterest': 'OP interest %',
  'settingsForm.overduePenalty': 'Overdue penalty',
  'settingsForm.reminderDays': 'Reminder days before due',
  'settingsForm.saveReminders': 'Save reminder settings',
  'settingsForm.subscriptionPlan': 'Current plan',
  'settingsForm.changePassword': 'Change password',
  'settingsForm.currentPassword': 'Current password',
  'settingsForm.newPassword': 'New password',
  'settingsForm.confirmPassword': 'Confirm password',
  'settingsForm.addAdmin': 'Add admin',
  'settingsForm.role': 'Role',
  'settingsForm.permissions': 'Permissions',
  'settingsForm.addOwner': 'Add owner',
  'settingsForm.shareholding': 'Shareholding %',

  'settingsDelete.warningTitle': 'Permanent workspace deletion',
  'settingsDelete.warningBody':
    'Submitting a request sends it to the platform administrator for review. If approved, your entire organization, all users, loans, finance records, and settings will be permanently deleted. This cannot be undone.',
  'settingsDelete.formTitle': 'Request deletion',
  'settingsDelete.formDesc': 'Only the organization owner can submit this request. A super admin must approve it before any data is removed.',
  'settingsDelete.reasonLabel': 'Why do you want to delete this workspace?',
  'settingsDelete.reasonPlaceholder': 'Briefly explain your reason (minimum 10 characters)…',
  'settingsDelete.confirmLabel': 'Type "{{name}}" to confirm',
  'settingsDelete.submit': 'Submit deletion request',
  'settingsDelete.submitting': 'Submitting…',
  'settingsDelete.submitted': 'Deletion request submitted. A platform admin will review it.',
  'settingsDelete.submitFailed': 'Could not submit deletion request.',
  'settingsDelete.confirmPrompt': 'Submit this deletion request? Your workspace will NOT be deleted until a platform admin approves it.',
  'settingsDelete.reasonTooShort': 'Please enter at least 10 characters explaining your reason.',
  'settingsDelete.confirmNameMismatch': 'Organization name does not match. Type it exactly as shown.',
  'settingsDelete.cancelRequest': 'Cancel pending request',
  'settingsDelete.cancelPrompt': 'Cancel your pending deletion request?',
  'settingsDelete.cancelled': 'Deletion request cancelled.',
  'settingsDelete.cancelFailed': 'Could not cancel deletion request.',
  'settingsDelete.submittedOn': 'Submitted {{date}}',
  'settingsDelete.yourReason': 'Your reason',
  'settingsDelete.adminNote': 'Admin note',
  'settingsDelete.status.pending': 'Pending review by platform admin',
  'settingsDelete.status.approved': 'Approved — deletion in progress',
  'settingsDelete.status.rejected': 'Request rejected',
  'settingsDelete.status.completed': 'Workspace deleted',
  'settingsDelete.status.cancelled': 'Request cancelled',
} as const;
